import React from "react";
import { SpsButton } from "@spscommerce/ds-react";
import { ButtonKind } from "@spscommerce/ds-shared";
import { useSpsLanguage } from "@spscommerce/i18n";

export type StatusStateProps = {
    backToLogin?: (event: React.MouseEvent<HTMLButtonElement>) => void;
    header: string;
    message?: string;
    imgSrc: string;
    alt: string;
    ignorePublicUrl?: boolean;
    supportInfo?: boolean;
};
export default function StatusState({
    backToLogin,
    header,
    message,
    imgSrc,
    alt,
    ignorePublicUrl,
    supportInfo,
}: StatusStateProps) {
    const { t } = useSpsLanguage();

    return (
        <>
            <img
                className="confirmation-image"
                src={ignorePublicUrl ? imgSrc : `${process.env.PUBLIC_URL}${imgSrc}`}
                alt={alt}
            />
            <h1 className="auth-content-header confirmation-page">{header}</h1>
            {message && (
                <p className="confirmation-message" data-testid="status-state-message">
                    {message}
                </p>
            )}
            {supportInfo && (
                <p className="text-center">
                    <span>
                        {t("cpauth.statusState.supportInfo", {
                            defaultValue: "For more information contact customer support:",
                        })}
                    </span>{" "}
                    <a href="mailto:support@spscommerce.com">support@spscommerce.com</a>
                </p>
            )}
            {backToLogin && (
                <SpsButton
                    className="mr-1 mb-1 auth-button confirmation-button"
                    kind={ButtonKind.CONFIRM}
                    onClick={backToLogin}
                    data-testid="back-to-login-button"
                >
                    {t("cpauth.statusState.proceedToLogin", { defaultValue: "Proceed to Login" })}
                </SpsButton>
            )}
        </>
    );
}
